<!-- src\App.vue -->
<template>
  <!-- Importacion de vue-sonner -->
  <Toaster position="top-center" richColors closeButton />

  <div class="fixed inset-0 z-50 overflow-y-auto" v-if="!isAuthenticated">
    <div class="min-h-screen">
      <LoginForm @login-success="handleLoginSuccess" @login-error="handleLoginError" :external-loading="isLoading" :illustration-image="canvaImage">
      </LoginForm>

      <div v-if="loginError" class="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-60">
        <div class="bg-red-100 border border-red-400 text-red-700 px-6 py-4 rounded-lg shadow-lg max-w-md mx-auto">
          <div class="flex items-center">
            <svg class="w-5 h-5 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
            </svg>
            <span>{{ loginError }}</span>
            <button @click="loginError = null" class="ml-4 text-red-500 hover:text-red-700">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isAuthenticated" class="min-h-screen bg-gray-50">
    <div v-if="sidebarOpen" class="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" @click="closeSidebar"></div>

    <div :class="[
      'fixed left-0 top-0 h-full bg-white shadow-lg z-70 transform transition-transform duration-300 ease-in-out',
      sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0',
      sidebarCollapsed ? 'lg:w-20' : 'lg:w-64',
      'w-64'
    ]">
      <div :class="[
        'flex items-center transition-all duration-300 bg-white h-16',
        sidebarCollapsed ? 'justify-center px-4' : 'justify-between px-6'
      ]">
        <div class="flex flex-col items-start">
          <div class="flex items-center mb-1">
            <img :class="[
              'w-auto transition-all duration-300 object-contain',
              sidebarCollapsed ? 'h-12' : 'h-12'
            ]" alt="Logo Efintel" :src="currentLogoSidebar">
          </div>
          <div v-if="!sidebarCollapsed" class="ml-0">
          </div>
        </div>

        <button v-if="!sidebarCollapsed" @click="closeSidebar" class="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <nav :class="[
        'flex-1 py-6 space-y-2 transition-all duration-300 overflow-y-auto',
        'h-[calc(100vh-4rem)]',
        sidebarCollapsed ? 'px-2' : 'px-4'
      ]">
        <div class="mb-4">
          <div class="group">
            <button v-if="puedeGestionarEmpresas" @click="toggleClientesDropdown" :class="[
              'w-full flex items-center rounded-lg transition-colors',
              sidebarCollapsed ? 'justify-center px-3 py-3' : 'justify-between px-4 py-3',
              'text-sm font-medium',
              clientesDropdownOpen ? 'text-blue-600 bg-blue-50' : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
            ]" :title="sidebarCollapsed ? 'Clientes' : ''">
              <div class="flex items-center">
                <svg class="w-5 h-5 flex-shrink-0" :class="sidebarCollapsed ? 'mr-0' : 'mr-3'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                <span v-if="!sidebarCollapsed">Clientes</span>
              </div>
              <svg v-if="!sidebarCollapsed" :class="[
                'w-4 h-4 transition-transform duration-200',
                clientesDropdownOpen ? 'rotate-180' : ''
              ]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>

            <div v-if="clientesDropdownOpen && !sidebarCollapsed" class="mt-2 ml-4 space-y-1">
              <div v-if="loadingEmpresas">
                <div class="flex items-center space-x-2 text-gray-500">
                </div>
              </div>

              <button v-for="empresa in empresasDisponibles" :key="empresa.id" @click="selectEmpresa(empresa)" :class="[
                'block w-full text-left px-4 py-2 text-sm rounded-md transition-colors',
                selectedEmpresa?.id === empresa.id
                  ? 'bg-blue-100 text-blue-800 font-medium'
                  : 'text-blue-600 hover:text-blue-800 hover:bg-blue-50'
              ]">
                {{ empresa.nombre_empresa || empresa.nombre }}
                <svg v-if="selectedEmpresa?.id === empresa.id" class="inline w-4 h-4 ml-2 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
              </button>

              <div v-if="!loadingEmpresas && empresasDisponibles.length === 0" class="px-4 py-2 text-sm text-gray-500">
                No hay empresas disponibles
              </div>
            </div>
          </div>
        </div>

        <div class="space-y-1">
          <a v-if="puedeVerHistoricos" @click="handleRegistroActividad" href="#" :class="[
            'flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors group',
            sidebarCollapsed ? 'justify-center px-3 py-3' : 'px-4 py-3'
          ]" :title="sidebarCollapsed ? 'Históricos' : ''">
            <svg class="w-5 h-5 flex-shrink-0 text-gray-400 group-hover:text-blue-500" :class="sidebarCollapsed ? 'mr-0' : 'mr-3'" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span v-if="!sidebarCollapsed">Registro de Actividad</span>
          </a>

          <button v-if="puedeVerAlarmas" @click="handleAlarmas" :class="[
            'w-full flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors group',
            sidebarCollapsed ? 'justify-center px-3 py-3' : 'px-4 py-3'
          ]" :title="sidebarCollapsed ? 'Alarmas' : ''">
            <svg class="w-5 h-5 flex-shrink-0 text-gray-400 group-hover:text-blue-500" :class="sidebarCollapsed ? 'mr-0' : 'mr-3'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.732 15.5c-.77.833.192 2.5 1.732 2.5z">
              </path>
            </svg>
            <span v-if="!sidebarCollapsed">Alarmas</span>
          </button>

          <button v-if="puedeVerUsuarios" @click="handleGestionarClientes" :class="[
            'w-full flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors group',
            sidebarCollapsed ? 'justify-center px-3 py-3' : 'px-4 py-3'
          ]" :title="sidebarCollapsed ? 'Usuarios' : ''">
            <svg class="w-5 h-5 flex-shrink-0 text-gray-400 group-hover:text-blue-500" :class="sidebarCollapsed ? 'mr-0' : 'mr-3'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z">
              </path>
            </svg>
            <span v-if="!sidebarCollapsed">Usuarios</span>
          </button>

          <button v-if="puedeGestionarEmpresas" @click="handleGestionarEmpresas" :class="[
            'w-full flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors group',
            sidebarCollapsed ? 'justify-center px-3 py-3' : 'px-4 py-3'
          ]" :title="sidebarCollapsed ? 'Empresas' : ''">
            <svg class="w-5 h-5 flex-shrink-0 text-gray-400 group-hover:text-blue-500" :class="sidebarCollapsed ? 'mr-0' : 'mr-3'" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4">
              </path>
            </svg>
            <span v-if="!sidebarCollapsed">Empresas</span>
          </button>

          <button v-if="puedeVerEquipos" @click="handleAnadirDispositivo" :class="[
            'w-full flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-50 rounded-lg transition-colors group',
            sidebarCollapsed ? 'justify-center px-3 py-3' : 'px-4 py-3'
          ]" :title="sidebarCollapsed ? 'Equipos' : ''">
            <svg class="w-5 h-5 flex-shrink-0 text-gray-400 group-hover:text-blue-500" :class="sidebarCollapsed ? 'mr-0' : 'mr-3'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z">
              </path>
            </svg>
            <span v-if="!sidebarCollapsed">Equipos</span>
          </button>
        </div>
      </nav>
    </div>

    <nav :class="[
      'bg-white fixed top-0 right-0 h-16 p-1 z-60 transition-all duration-300',
      sidebarCollapsed ? 'lg:left-20' : 'lg:left-64',
      'left-0'
    ]">
      <div class="h-full flex items-center justify-between relative px-4">
        <div class="flex items-center space-x-3 lg:hidden">
          <button @click="toggleSidebar" class="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-colors">
            <svg v-if="!sidebarOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
            <svg v-else class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>

          <div class="flex items-center">
            <img class="w-auto h-7" alt="Logo Efintel" :src="LogoEfintelReducido">
          </div>
        </div>

        <div class="hidden lg:block">
          <button @click="toggleSidebarCollapse" class="p-2 rounded-md bg-white text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="sidebarCollapsed ? 'M13 5l7 7-7 7M5 5l7 7-7 7' : 'M11 19l-7-7 7-7m8 14l-7-7 7-7'"></path>
            </svg>
          </button>
        </div>

        <div class="flex items-center space-x-4">
          <div class="hidden sm:flex items-center space-x-3">
            <span class="text-blue-600 text-sm">{{ formatDate(currentDate) }}</span>
            <span class="text-blue-600 text-sm">{{ currentTime }}</span>
          </div>

          <div class="sm:hidden">
            <span class="text-blue-600 text-sm font-medium">{{ currentTime }}</span>
          </div>

          <NotificacionesDropdown v-if="currentUser" :userId="getCurrentUserId()" />

          <div class="relative">
            <button @click="toggleUserMenu" class="flex items-center space-x-2 focus:outline-none hover:bg-gray-50 px-2 py-1 rounded transition-colors">
              <div class="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-blue-500 flex items-center justify-center">
                <span class="text-white font-medium text-sm">{{ getUserInitials() }}</span>
              </div>
              <span class="text-blue-600 hidden sm:block text-sm">{{ getUserDisplayName() }}</span>
              <svg :class="[
                'w-4 h-4 text-blue-600 transition-transform duration-200 hidden sm:block',
                isUserMenuOpen ? 'rotate-180' : 'rotate-0'
              ]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            <div v-show="isUserMenuOpen" class="absolute top-full right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-70 border border-gray-200">
              <button @click="changePassword" class="block w-full text-left px-4 py-2 text-sm text-blue-600 hover:bg-gray-100">
                Cambiar Contraseña
              </button>
              <div class="border-t border-gray-200 my-1"></div>
              <button @click="logout" :disabled="isLoading" class="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100 disabled:opacity-50">
                <div class="flex items-center">
                  <svg v-if="isLoading" class="animate-spin h-4 w-4 mr-2 text-red-600" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                  </svg>
                  {{ isLoading ? 'Cerrando...' : 'Cerrar Sesión' }}
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <div class="h-16 bg-efintelwhite-50"></div>

    <div :class="[
      'transition-all duration-300 pt-0',
      sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'
    ]">
      <AppContent :selectedEmpresa="selectedEmpresa" :selectedLocal="selectedLocal" :empresasDisponibles="empresasDisponibles" @local-selected="handleLocalSelected" @empresa-selected="handleEmpresaSelected" @back-to-empresas="handleBackToEmpresas" @back-to-locales="handleBackToLocales" />
    </div>

    <ManageAccount :isOpen="showManageAccountModal" @close="showManageAccountModal = false" />

    <ManageCompany :isOpen="showManageCompanyModal" @empresa-changed="handleEmpresaChange" @close="showManageCompanyModal = false" />

    <ChangePassword :isOpen="showChangePasswordModal" :currentUser="currentUser" @close="showChangePasswordModal = false" @success="handleChangePasswordSuccess" @error="handleChangePasswordError" />
    <AlarmasView :isOpen="showAlarmasModal" @close="showAlarmasModal = false" />
    <ModalGestionEquipos :visible="showGestionEquiposModal" @cerrar="cerrarModalGestionEquipos" />
    <RegistroActividad :isOpen="showRegistroActividadModal" @close="showRegistroActividadModal = false" />
  </div>
  <!-- Modal soft lock para reautenticación sin perder el progreso actual -->
  <div v-if="sessionState.isSoftLocked && isAuthenticated" class="fixed inset-0 z-[100] bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center">
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-md p-8 transform transition-all border border-gray-100 mx-4">
      <div class="text-center mb-6">
        <div class="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg class="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
          </svg>
        </div>
        <h2 class="text-2xl font-bold text-gray-800 mb-2">Sesión Pausada</h2>
        <p class="text-sm text-gray-500">Por motivos de seguridad, tu sesión ha expirado. Por favor, ingresa tu contraseña para reanudar sin perder tu trabajo actual.</p>
      </div>

      <form @submit.prevent="handleUnlockSession">
        <div class="mb-5">
          <label class="block text-sm font-medium text-gray-700 mb-1">Correo electrónico</label>
          <input type="email" :value="currentUser?.email" disabled class="w-full px-4 py-2 bg-gray-100 border border-gray-300 rounded-lg text-gray-500 cursor-not-allowed focus:outline-none" />
        </div>

        <div class="mb-6">
          <label class="block text-sm font-medium text-gray-700 mb-1">Contraseña</label>
          <input type="password" v-model="unlockPassword" ref="unlockInput" required placeholder="Ingresa tu contraseña" class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors" />
        </div>

        <div class="flex flex-col space-y-3">
          <button type="submit" :disabled="isUnlocking" class="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-lg transition-colors flex justify-center items-center">
            <svg v-if="isUnlocking" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ isUnlocking ? 'Reanudando...' : 'Reanudar Sesión' }}
          </button>

          <button type="button" @click="forceLogoutFromSoftLock" :disabled="isUnlocking" class="w-full bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium py-2.5 px-4 rounded-lg transition-colors">
            Cerrar sesión
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" v-if="isLoading && isAuthenticated">
    <div class="bg-white rounded-lg p-6 flex items-center space-x-3">
      <svg class="animate-spin h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
        </path>
      </svg>
      <span class="text-gray-900">Procesando...</span>
    </div>
  </div>

</template>

<script>
import LogoEfintelReducido from './assets/EfintelLogoReducido.png'
import LogoNuevoEfintel from './assets/logoNuevoEfintel.png'
import { toast } from 'vue-sonner'

import AppContent from './components/app/AppContent.vue'
import LoginForm from './components/auth/LoginForm.vue'
import ManageAccount from './components/auth/ManageAccount.vue'
import ChangePassword from './components/auth/ChangePassword.vue'
import ManageCompany from './components/auth/ManageCompany.vue'
import AlarmasView from './components/dashboard/AlarmasView.vue'
import ModalGestionEquipos from './components/dispositivos/ModalGestionEquipos.vue'
import RegistroActividad from './components/dashboard/RegistroActividad.vue'
import NotificacionesDropdown from './components/app/Notificacionesdropdown.vue'

import AuthService from './services/auth/auth.js'
import PermissionsService from '@/services/auth/permissions.js'
import { sessionState } from '@/state/sessionState'

export default {
  name: 'App',
  components: {
    AppContent,
    LoginForm,
    ManageAccount,
    ManageCompany,
    ChangePassword,
    AlarmasView,
    ModalGestionEquipos,
    RegistroActividad,
    NotificacionesDropdown
  },
  data() {
    return {
      // === AUTENTICACIÓN ===
      isAuthenticated: false,
      currentUser: null,
      authToken: null,
      permisosVersion: 0,
      loginError: null,
      isLoading: false,
      isUserMenuOpen: false,
      showChangePasswordModal: false,
      showGestionEquiposModal: false,
      sessionState,
      unlockPassword: '',
      isUnlocking: false,

      // === NAVEGACIÓN EMPRESA → LOCAL ===
      selectedEmpresa: null,
      selectedLocal: null,
      empresasDisponibles: [],
      loadingEmpresas: false,

      showAlarmasModal: false,
      // === UI NAVBAR ===
      mobileMenuOpen: false,
      LogoEfintelReducido,
      LogoNuevoEfintel,
      showManageAccountModal: false,
      showManageCompanyModal: false,
      showRegistroActividadModal: false,
      sidebarOpen: false,
      sidebarCollapsed: false,
      clientesDropdownOpen: true,

      // === TIEMPO ===
      currentDate: new Date(),
      currentTime: '',
      empresaPollingInterval: null,
      timeInterval: null,
    }
  },
  computed: {
    currentLogoSidebar() {
      // Si el sidebar está colapsado (cerrado), muestra el reducido. Si no, el nuevo.
      return this.sidebarCollapsed ? this.LogoEfintelReducido : this.LogoNuevoEfintel;
    },
    // ========================================
    // PERMISOS COMPUTADOS
    // ========================================
    puedeVerHistoricos() {
      this.permisosVersion
      return PermissionsService.can('historicos', 'ver')
    },
    puedeVerAlarmas() {
      this.permisosVersion
      return PermissionsService.can('alarmas', 'ver')
    },
    puedeVerUsuarios() {
      this.permisosVersion
      return PermissionsService.can('usuarios', 'ver_todos')
    },
    puedeVerEquipos() {
      this.permisosVersion
      return PermissionsService.can('equipos', 'ver')
    },
    puedeVerEmpresas() {
      this.permisosVersion
      return PermissionsService.can('empresas', 'ver')
    },
    puedeVerPropiaEmpresa() {
      this.permisosVersion
      return PermissionsService.can('empresas', 'ver_propias')
    },
    puedeGestionarEmpresas() {
      this.permisosVersion
      return PermissionsService.can('empresas', 'ver_todas')
    },
    // ========================================
  },
  async mounted() {
    await this.checkExistingSession()
    this.updateTime()
    this.timeInterval = setInterval(this.updateTime, 1000)

    // === INICIO DE POLLING PARA EMPRESAS ===
    // Recarga la lista de empresas cada 30 segundos para mantenerla actualizada
    this.empresaPollingInterval = setInterval(() => {
      if (this.isAuthenticated) {
        this.loadEmpresasDisponibles();
      }
    }, 30000); // 30000 ms = 30 segundos

    document.addEventListener('keydown', this.handleEscapeKey)
    window.addEventListener('click', this.closeUserMenu);
  },

  beforeUnmount() {
    clearInterval(this.timeInterval);
    clearInterval(this.empresaPollingInterval); // Limpiar el intervalo de empresas
    document.removeEventListener('keydown', this.handleEscapeKey)
    window.removeEventListener('click', this.closeUserMenu);
  },

  methods: {
    // ========================================
    // === AUTENTICACIÓN Y SESIÓN ===
    // ========================================
    // Método que procesa la contraseña ingresada en el Soft Lock
    async handleUnlockSession() {
      if (!this.unlockPassword) return;

      this.isUnlocking = true;
      try {
        // Re-loguea al usuario usando el correo guardado en currentUser y la contraseña escrita
        await AuthService.login({
          email: this.currentUser.email,
          password: this.unlockPassword
        });

        // Si fue exitoso, limpiamos y ocultamos el modal
        this.unlockPassword = '';
        this.sessionState.isSoftLocked = false;
        toast.success('Sesión reanudada correctamente. Puedes continuar.');

      } catch (error) {
        toast.error('Contraseña incorrecta. Inténtalo de nuevo.');
        this.unlockPassword = '';
      } finally {
        this.isUnlocking = false;
      }
    },

    // Método si el usuario decide abortar e irse al login real
    async forceLogoutFromSoftLock() {
      this.sessionState.isSoftLocked = false;
      this.unlockPassword = '';
      await this.logout(); // Ejecuta tu función logout() existente
    },
    async checkExistingSession() {
      this.isLoading = true
      try {
        // Ahora validateToken no necesita un token, usa cookies/JWT interno.
        const userData = await AuthService.validateToken()

        this.handleLoginSuccess({
          user: userData
        })
      } catch (error) {
        AuthService.clearAuth() // Limpia cualquier residuo de sesión inválida.
      } finally {
        this.isLoading = false
      }
    },

    handleLoginSuccess(response) {
      this.isAuthenticated = true
      this.currentUser = response.user
      this.loginError = null

      //   CARGAR EMPRESAS DESPUÉS DEL LOGIN
      this.loadInitialData()
      // FORZAR RECALCULO DE PERMISOS
      this.$nextTick(() => {
        this.permisosVersion++
      })
    },

    handleLoginError(error) {
      toast.error(error.message || 'Error desconocido al iniciar sesión')
      this.isAuthenticated = false
      this.currentUser = null
      this.authToken = null
    },

    async logout() {
      this.isLoading = true

      try {
        // ✅ SIEMPRE intentar logout en el servidor (sin verificar authToken local)
        await AuthService.logout()

      } catch (error) {
        // No bloquear el logout aunque falle el servidor

      } finally {
        // SIEMPRE limpiar localmente

        this.isAuthenticated = false
        this.currentUser = null
        this.authToken = null
        this.loginError = null
        this.selectedEmpresa = null
        this.selectedLocal = null
        this.empresasDisponibles = []

        AuthService.clearAuth()

        this.isLoading = false
        this.isUserMenuOpen = false
        this.permisosVersion++
      }
    },

    // ========================================
    // === CARGA DE DATOS Y NAVEGACIÓN ===
    // ========================================

    /**
     * MEJORADO: Carga datos iniciales incluyendo empresas
     */
    async loadInitialData() {
      try {
        // Cargar empresas disponibles
        await this.loadEmpresasDisponibles()

        // Aquí puedes cargar otros datos iniciales
        // const configuracion = await ApiService.getConfiguracionUsuario()

      } catch (error) {
        // No bloquear el login por errores de datos iniciales
      }
    },

    /**
     * Carga empresas disponibles para el usuario
     */
    async loadEmpresasDisponibles() {
      if (this.loadingEmpresas) return;

      this.loadingEmpresas = true;
      try {
        // ADAPTAR SEGÚN TU API
        const response = await AuthService.authenticatedRequest('/empresas/api/empresa/');

        // Manejar respuesta paginada o directa
        let empresas = Array.isArray(response) ? response : response.results || [];

        // ==========================================
        // FILTRAR EMPRESAS SEGÚN PERMISOS
        // ==========================================

        // Si puede ver TODAS las empresas
        if (this.puedeGestionarEmpresas) {
          // No filtrar, mostrar todas

          // Si solo puede ver SU PROPIA empresa
        } else if (this.puedeVerPropiaEmpresa) {
          // Obtener empresa del usuario actual
          const empresaUsuario = this.currentUser?.empresa_id || this.currentUser?.empresa

          if (empresaUsuario) {
            // Filtrar solo la empresa del usuario
            empresas = empresas.filter(empresa => empresa.id === empresaUsuario)
          } else {
            empresas = []
          }

          // Si NO tiene ningún permiso de empresas
        } else {
          empresas = []
        }

        // ✅ Ordenar alfabéticamente por nombre de empresa
        empresas.sort((a, b) => {
          const nameA = (a.nombre_empresa || a.nombre || '').toLowerCase();
          const nameB = (b.nombre_empresa || b.nombre || '').toLowerCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });

        this.empresasDisponibles = empresas;

        // AUTO-SELECCIONAR SI SOLO HAY UNA EMPRESA
        if (empresas.length === 1 && !this.selectedEmpresa) {
          this.selectEmpresa(empresas[0])
        }

      } catch (error) {
        this.empresasDisponibles = [];

      } finally {
        this.loadingEmpresas = false;
      }
    },

    /**
     * Selecciona una empresa
     */
    selectEmpresa(empresa) {
      this.selectedEmpresa = empresa;
      this.selectedLocal = null; // Reset local al cambiar empresa

      // Cerrar sidebar en móvil
      this.closeSidebar();
    },
    handleEmpresaSelected(empresa) {
      this.selectedEmpresa = empresa;
      this.selectedLocal = null;
    },
    /**
     * Maneja selección de local desde AppContent
     */
    handleLocalSelected(local) {
      this.selectedLocal = local;
    },

    /**
     * Vuelve a la vista de empresas
     */
    handleBackToEmpresas() {
      this.selectedEmpresa = null;
      this.selectedLocal = null;
    },

    /**
     * Vuelve a la vista de locales
     */
    handleBackToLocales() {
      this.selectedLocal = null;
    },

    // ========================================
    // === MANEJO DE UI (SIDEBAR, MENÚS) ===
    // ========================================
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen

      // Prevenir scroll del body en móvil
      if (this.sidebarOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },

    openSidebar() {
      this.sidebarOpen = true
    },

    closeSidebar() {
      this.sidebarOpen = false
    },

    toggleSidebarCollapse() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },

    toggleClientesDropdown() {
      this.clientesDropdownOpen = !this.clientesDropdownOpen
    },

    toggleUserMenu(event) {
      event.stopPropagation();
      this.isUserMenuOpen = !this.isUserMenuOpen;
    },

    closeUserMenu(event) {
      // Cierra el menú si se hace clic fuera de él
      if (this.$el.contains(event.target) && !event.target.closest('.relative')) {
        this.isUserMenuOpen = false;
      }
    },

    // ========================================
    // === MANEJADORES DE ACCIONES Y MODALES ===
    // ========================================
    handleRegistroActividad() {
      this.showRegistroActividadModal = true
      this.closeSidebar()  // Cerrar sidebar en móvil
    },
    handleAlarmas() {
      this.showAlarmasModal = true
      this.closeSidebar()  // Cerrar sidebar en móvil
    },

    changePassword() {
      this.showChangePasswordModal = true
      this.isUserMenuOpen = false
    },

    handleChangePasswordSuccess(message) {
      console.log("Password change successful:", message)
      // Opcional: mostrar notificación toast
    },

    handleChangePasswordError(error) {
      console.error("Password change error:", error)
      // Opcional: mostrar notificación de error
    },

    handleGestionarClientes() {
      this.showManageAccountModal = true
      this.closeSidebar()
    },

    handleGestionarEmpresas() {
      this.showManageCompanyModal = true
      this.closeSidebar()
    },

    handleEmpresaChange() {
      this.loadEmpresasDisponibles();
    },
    cerrarModalGestionEquipos() {
      this.showGestionEquiposModal = false
    },
    handleAnadirDispositivo() {
      this.showGestionEquiposModal = true
      this.closeSidebar()
    },
    onDispositivoCreated(dispositivo) {
      this.showDispositivosModal = false
      toast.success(`Dispositivo "${dispositivo.nombre_dispositivo}" creado exitosamente`)
    },

    // ========================================
    // === MÉTODOS UI EXISTENTES ===
    // ========================================
    updateTime() {
      const now = new Date()
      this.currentTime = now.toLocaleTimeString('es-CL', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      })
    },

    formatDate(date) {
      return date.toLocaleDateString('es-CL', {
        weekday: 'long',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    },

    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },

    closeMobileMenu() {
      this.mobileMenuOpen = false
    },

    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.mobileMenuOpen) {
        this.closeMobileMenu()
      }
    },

    // ========================================
    // === MÉTODOS AUXILIARES (HELPERS) ===
    // ========================================
    getUserInitials() {
      if (!this.currentUser) return 'U'

      const nombre = this.currentUser.nombre

      if (nombre && nombre.trim()) {
        return nombre.trim().charAt(0).toUpperCase()
      }

      if (this.currentUser.email) {
        return this.currentUser.email.charAt(0).toUpperCase()
      }

      return 'U'
    },

    getUserDisplayName() {
      if (!this.currentUser) return 'Usuario'

      if (this.currentUser.nombre && this.currentUser.nombre.trim()) {
        return this.currentUser.nombre.trim()
      }

      return this.currentUser.email || 'Usuario Desconocido'
    },

    getCurrentUserId() {
      // Retornar el ID del usuario actual desde los datos que ya tienes
      return this.currentUser?.id || this.currentUser?.pk || null
    },
  }
}
</script>

<style>
.z-60 {
  z-index: 60;
}

.z-65 {
  z-index: 65;
}

.z-70 {
  z-index: 70;
}

.sidebar-container {
  isolation: isolate;
}

/* Transiciones para el menú móvil */
.mobile-menu-enter-active,
.mobile-menu-leave-active {
  transition: all 0.3s ease;
}

.mobile-menu-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.mobile-menu-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Prevenir scroll cuando el menú está abierto */
body.menu-open {
  overflow: hidden;
}

/* Animaciones para dropdown de empresas */
.empresa-enter-active,
.empresa-leave-active {
  transition: all 0.2s ease;
}

.empresa-enter-from {
  opacity: 0;
  transform: translateX(-10px);
}

.empresa-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

.modal-open {
  overflow: hidden;
}

/* Estilos globales de scroll */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Specific overrides for overflow containers */
.overflow-x-auto::-webkit-scrollbar,
.overflow-y-auto::-webkit-scrollbar,
.overflow-auto::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.overflow-x-auto::-webkit-scrollbar-track,
.overflow-y-auto::-webkit-scrollbar-track,
.overflow-auto::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.overflow-x-auto::-webkit-scrollbar-thumb,
.overflow-y-auto::-webkit-scrollbar-thumb,
.overflow-auto::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.overflow-x-auto::-webkit-scrollbar-thumb:hover,
.overflow-y-auto::-webkit-scrollbar-thumb:hover,
.overflow-auto::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>